import {createReducer} from '@reduxjs/toolkit';
import {cleanCounts} from 'src/modules/tabs-panel/services/actions';
import {getUniqueAttributeTitleCountSuccess} from 'src/openapi/apis/AttributeControllerApi';
import {getChangeRequestCountSuccess} from 'src/openapi/apis/ChangeRequestControllerApi';
import {getEventCountSuccess} from 'src/openapi/apis/EventControllerApi';

type State = {
    data: {
        events: number,
        attributes: number,
        changeRequests: number,
    },
};

const defaultState = {
    data: {
        events: 0,
        attributes: 0,
        changeRequests: 0,
    },
};

export const counts = createReducer<State>(defaultState, builder => builder
    .addCase(getEventCountSuccess, (state, action) => {
        state.data = {...state.data, events: action.payload.data};
    })
    .addCase(getUniqueAttributeTitleCountSuccess, (state, action) => {
        state.data = {...state.data, attributes: action.payload.data};
    })
    .addCase(getChangeRequestCountSuccess, (state, action) => {
        state.data = {...state.data, changeRequests: action.payload.data};
    })
    .addCase(cleanCounts, state => {
        state.data = {...defaultState.data};
    }),
);
